import React, {
  Fragment,
  lazy,
  ReactNode,
  Suspense,
  useCallback,
  useEffect,
  useState,
} from "react";
import { Container, Grid, Card, Button, Divider } from "@material-ui/core";
import {
  getConfig,
  getPorfoliCard,
  getPublicPortfolio,
  http,
  UserAPI,
} from "adapters";
import { useHistory, useParams } from "react-router-dom";
import { Informations } from "./informations";
import roundedButtonStyle from "styles/buttons/rounded-button.module.scss";
import AddIcon from "@material-ui/icons/Add";
import {
  GetUrlBuilderPublicData,
  selectBuilderPublicPermissions,
  SetBuilderPublicPermissions,
  SetUrlBuilderPublicData,
} from "store/url-builder-public";
import { useSelector, useDispatch } from "react-redux";
import "styles/player.css";
import { AppRoute } from "enums/appRoute";
import { PortfolioFooter } from "components/portfolio/footer";
import { SetConfigData } from "store/config/actions";
import { SetCard, GetCardData } from "store/card";
import axios from "axios";
import { Cookies } from "react-cookie";
import useLocalStorage from "react-use-localstorage";
import { getBuilderPermissions } from "adapters";
import CardImage from "./CardImage/index";
import InformationsShimmer from "./informations/InformationsShimmer";
import ShimmerBox from "components/shared/shimmer-box";
import SectionsShimmer from "./SectionsShimmer";
import Sections from "./sections";
import { ObjectPermissionSetData } from "types/permissions";
import { findPermission } from "utils/permissions";

//sections
const DynamicUrl = lazy(() => import("./sections/DymaicUrl"));

export default function Portfolio() {
  const params: any = useParams();
  const portfolio = useSelector(GetUrlBuilderPublicData);

  const dispatch = useDispatch();
  const history = useHistory();
  const portCard = useSelector(GetCardData);
  const [loading, setLoading] = useState(true);
  const [mycardsLoading, setMycardsLoading] = useState(true);

  const [, setToken] = useLocalStorage("token");
  const [portfolioType, setPortfolioType] = useState("published");
  const [isMobile, setMobile] = React.useState(false);
  const [userAgent, setUserAgent] = React.useState("");

  const [businessCard, setBusinessCard] = useState<ReactNode | null>(null);

  const portfolioPermissions = useSelector(selectBuilderPublicPermissions);
  const permission = useCallback(
    (filter: { moduleId: number; permissionName: string }) =>
      findPermission(portfolioPermissions as ObjectPermissionSetData[], filter)
        ?.objectPermissionValue,
    [portfolioPermissions]
  );

  const checkSession = async () => {
    //TODO:
    //checkIsTokenValid();
    //call identity POST /connect/introspect with token if god and expires in more than half lifetime ok

    const cookies = new Cookies();
    const phpsessid = cookies.get("PHPSESSID");
    const ci_session = cookies.get("ci_session");

    const csData = {
      phpsessid: phpsessid,
      ci_session: ci_session,
    };
    const response = await http.post(UserAPI.CHECKSESSION, csData);
    console.log("check-session response:\n\n" + response);
    if (response.data.indexOf("nije_token") === -1) {
      setToken(response.data);
    } else {
      window.location.replace(window.location.origin + "/pro/index/login");
    }
  };

  const initPortfolio = async function () {
    await checkSession();
    var pt = "published";
    if (params.preview === "preview") {
      setPortfolioType("preview");
      pt = "preview";
    }

    getConfig().then((response: any) => {
      dispatch(SetConfigData(response.data));
    });

    axios
      .all([
        getPublicPortfolio(params.id, { id: params.id }, pt),
        getBuilderPermissions(params.id, "PRO", "true"),
      ])
      .then(
        axios.spread(({ data: portfolio }, { data: permissions }) => {
          dispatch(
            SetBuilderPublicPermissions(permissions.data.objectPermissions)
          );
          dispatch(SetUrlBuilderPublicData(portfolio.data));
          setLoading(false);
        })
      );

    getPorfoliCard(params.id).then(({ data: card }) => {
      dispatch(SetCard(card));
      setMycardsLoading(false);
    });
  };

  const downloadVcf = async function () {
    window.location.href =
      window.location.origin + "/card_download/" + portCard.profileId;
  };

  useEffect(() => {
    //  TODO: Redirect to home page when created
    if (!params.id) return history.replace(AppRoute.LOGIN);

    setBusinessCard(<CardImage cardId={params.id} builderType="PRO" />);

    initPortfolio();
  }, []);

  useEffect(() => {
    const userAgentMy =
      typeof window.navigator === "undefined" ? "" : navigator.userAgent;
    const mobile = Boolean(
      userAgentMy.match(
        /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
      )
    );
    setMobile(mobile);
    setUserAgent(userAgentMy);
  }, []);

  return (
    <Fragment>
      <Container maxWidth={isMobile ? false : "sm"} className="root-wrapper">
        <Grid container justifyContent="center">
          <Grid item container xs={12} spacing={0}>
            <Grid item xs={12}></Grid>
            <Grid item xs={12}>
              {businessCard}
            </Grid>

            <Suspense fallback={() => null}>
              {!loading &&
                /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                  navigator.userAgent
                ) &&
                portCard.dynamicUrl && (
                  <DynamicUrl portCard={portCard} portfolio={portfolio} />
                )}
            </Suspense>

            <Grid item xs={12} className="mb-1 mt-3">
              <Card>
                <Container
                  maxWidth={isMobile ? false : "sm"}
                  className="mt-4 mb-4"
                >
                  <Grid container spacing={3}>
                    {(portfolioType === "preview" ||
                      permission({
                        moduleId: 2,
                        permissionName: "visible",
                      })) && (
                      <Fragment>
                        <Grid item xs={12}>
                          {(mycardsLoading || loading) && (
                            <InformationsShimmer />
                          )}
                          {!mycardsLoading && !loading && (
                            <Informations portfolioType={portfolioType} />
                          )}
                        </Grid>
                        <Grid item xs={12}>
                          <Divider light />
                        </Grid>
                      </Fragment>
                    )}
                    <Grid item xs={12}>
                      {loading && (
                        <ShimmerBox
                          height="45px"
                          width="100%"
                          classes={roundedButtonStyle.root}
                        />
                      )}
                      {!loading && (
                        <Button
                          onClick={downloadVcf}
                          style={{
                            backgroundColor: portfolio.primaryColor.color,
                            color: "#fff",
                          }}
                          className={roundedButtonStyle.root}
                          size="large"
                          variant="contained"
                          color="primary"
                          fullWidth
                        >
                          <AddIcon /> Add to Contacts
                        </Button>
                      )}
                    </Grid>
                    <Grid item xs={12}>
                      <Divider light />
                    </Grid>
                    {loading && <SectionsShimmer />}
                    <Suspense fallback={<SectionsShimmer />}>
                      {!loading && (
                        <Sections
                          portCard={portCard}
                          portfolio={portfolio}
                          portfolioType={portfolioType}
                          userAgent={userAgent}
                        />
                      )}
                    </Suspense>
                    <Grid item xs={12}></Grid>
                  </Grid>
                </Container>
                <PortfolioFooter />
              </Card>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Fragment>
  );
}
